import React from 'react';
import { BRAND_NAME } from '../utils/brand';

/**
 * Brand wordmark.
 *  - Full lockup  → /fullLogo.png   (default — navbar, footer)
 *  - Icon only    → /LogoICON.png   (pass iconOnly when space is tight)
 *
 * Brand label is env-driven via REACT_APP_BRAND_NAME so a single .env edit
 * re-labels alt-text everywhere.
 */
export default function Logo({ className = '', height = 40, iconOnly = false }) {
  const src = iconOnly ? '/LogoICON.png' : '/fullLogo.png';
  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={src}
        alt={BRAND_NAME}
        className="block w-auto select-none"
        style={{ height }}
        draggable="false"
      />
    </div>
  );
}
